import { Typography } from '@material-ui/core'
import React, { useEffect, useState } from 'react'
import icDelete from '../../assets/ic_delete3.png'
import { formatCurrency } from '../../library/Util';

export default function ListDataPayment(props) {
    const [data, setData] = useState([])

    const forceUpdate = React.useReducer(bool => !bool)[1];

    useEffect(() => {
        console.log(props)
        if (props.data.length > 0) {
            setData(props.data)
            forceUpdate()
        }
    }, [])

    return (
        <div>
            {data.length > 0 ?
                data.map((item, index) => {
                    let total = 0
                    return (
                        <div>
                            {index === 0 && (
                                <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 20, padding: 20 }}>
                                    <div style={{ width: '16%' }}>
                                        <Typography style={{ fontSize: 14, color: '#278863', textAlign: 'left' }}>Tipe Biaya</Typography>
                                    </div>
                                    <div style={{ width: '16%' }}>
                                        <Typography style={{ fontSize: 14, color: '#278863', textAlign: 'left' }}>Keterangan Biaya</Typography>
                                    </div>
                                    <div style={{ width: '8%' }}>
                                        <Typography style={{ fontSize: 14, color: '#278863', textAlign: 'left' }}>Qty</Typography>
                                    </div>
                                    <div style={{ width: '21%' }}>
                                        <Typography style={{ fontSize: 14, color: '#278863', textAlign: 'left' }}>Keterangan Tambahan</Typography>
                                    </div>
                                    <div style={{ width: '17%' }}>
                                        <Typography style={{ fontSize: 14, color: '#278863', textAlign: 'left' }}>Amount</Typography>
                                    </div>
                                    <div style={{ width: '17%', display: 'flex', justifyContent: 'space-between' }}>
                                        <div style={{ marginRight: 20 }}>
                                            <Typography style={{ fontSize: 14, color: '#278863', textAlign: 'left' }}>Total Amount</Typography>
                                        </div>
                                        <div style={{ width: 60 }}>
                                            <Typography style={{ fontSize: 14, color: '#278863', textAlign: 'left' }}>Aksi</Typography>
                                        </div>
                                    </div>
                                </div>
                            )}
                            <div style={{ padding: '0 20px' }}>
                                <div style={{ backgroundColor: '#e7ffec', borderRadius: 20}}>
                                    {item.val && item.val.map((i, idx) => {
                                        let hasil = Number(i[4]) * Number(i[2])
                                        if (item.id !== 2 && item.id !== 4 && item.id !== 5) {
                                            total += Number(hasil)
                                        } else {
                                            total += Number(i[8])
                                        }
                                        return (
                                            <div style={{ display: 'flex', justifyContent: 'space-between', padding: '10px 0px', borderBottom: idx !== item.val.length - 1 ? '2px solid #9adaa8' : '' }}>
                                                <div style={{ width: '16%' }}>
                                                    <Typography style={{ fontSize: 12, color: 'black', textAlign: 'left' }}>{i[0]}</Typography>
                                                </div>
                                                <div style={{ width: '16%' }}>
                                                    <Typography style={{ fontSize: 12, color: 'black', textAlign: 'left' }}>{i[1]}</Typography>
                                                </div>
                                                <div style={{ width: '8%' }}>
                                                    <Typography style={{ fontSize: 12, color: 'black', textAlign: 'left' }}>{i[2]}</Typography>
                                                </div>
                                                <div style={{ width: '21%' }}>
                                                    <Typography style={{ fontSize: 12, color: 'black', textAlign: 'left' }}>{i[3]}</Typography>
                                                </div>
                                                <div style={{ width: '17%' }}>
                                                    <Typography style={{ fontSize: 12, color: 'black', textAlign: 'left' }}>Rp. {formatCurrency(i[4])}</Typography>
                                                </div>
                                                {(item.id !== 2 && item.id !== 4 && item.id !== 5) ? (
                                                    <div style={{ width: '17%', display: 'flex', justifyContent: 'space-between' }}>
                                                        <div style={{ marginRight: 20 }}>
                                                            <Typography style={{ fontSize: 12, color: 'black', textAlign: 'right' }}>Rp. {formatCurrency(hasil)}</Typography>
                                                        </div>
                                                        <div style={{ width: 60, alignSelf: 'center', display: 'flex', justifyContent: 'center' }}>
                                                            <img
                                                                onClick={() => {
                                                                    props.deletePayment(item, index, idx)
                                                                    console.log(item);
                                                                    console.log(index);
                                                                    console.log(idx);
                                                                    // item.val.length === 0 ?
                                                                    //     data.splice(index, 0) :
                                                                    //     data[index].val.splice(idx, 0)
                                                                    // console.log(data);
                                                                    // forceUpdate()
                                                                }}
                                                                src={icDelete} style={{ width: 20, height: 20, cursor: 'pointer' }} />
                                                        </div>

                                                    </div>
                                                ) :
                                                    <div style={{ width: '17%', display: 'flex', justifyContent: 'space-between' }} >
                                                        <div style={{ marginRight: 20 }}>
                                                            <Typography style={{ fontSize: 12, color: 'black', textAlign: 'right' }}>Rp. {formatCurrency(i[8])}</Typography>
                                                        </div>
                                                    </div>
                                                }
                                            </div>
                                        )
                                    })}
                                </div>
                            </div>
                            <div style={{ display: 'flex', justifyContent: 'space-between', padding: 13 }}>
                                <div>
                                    <Typography style={{ fontSize: 14, color: 'black', textAlign: 'left' }}>Total Biaya {item.name}</Typography>
                                </div>
                                <div style={{ width: '16.5%', marginRight: 10 }}>
                                    <Typography style={{ fontSize: 14, color: 'black', textAlign: 'left' }}>Rp. {formatCurrency(total)}</Typography>
                                </div>
                            </div>
                        </div>
                    )
                })
                :
                <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 20 }}>
                    <div style={{}}>
                        <Typography style={{ fontSize: 14, color: '#278863', textAlign: 'left' }}>Tipe Biaya</Typography>
                    </div>
                    <div style={{}}>
                        <Typography style={{ fontSize: 14, color: '#278863', textAlign: 'left' }}>Keterangan Biaya</Typography>
                    </div>
                    <div style={{}}>
                        <Typography style={{ fontSize: 14, color: '#278863', textAlign: 'left' }}>Qty</Typography>
                    </div>
                    <div style={{}}>
                        <Typography style={{ fontSize: 14, color: '#278863', textAlign: 'left' }}>Keterangan Tambahan</Typography>
                    </div>
                    <div style={{}}>
                        <Typography style={{ fontSize: 14, color: '#278863', textAlign: 'left' }}>Amount</Typography>
                    </div>
                    <div style={{}}>
                        <Typography style={{ fontSize: 14, color: '#278863', textAlign: 'left' }}>Total Amount</Typography>
                    </div>
                    <div style={{ width: 60 }}>
                        <Typography style={{ fontSize: 14, color: '#278863', textAlign: 'left' }}>Aksi</Typography>
                    </div>
                </div>
            }
        </div>
    )
}
